import React from "react";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-blue-800 text-white pt-10">
      <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-8 pb-10">
        
        {/* Información del colegio */}
        <div className="md:col-span-1">
          <h3 className="text-2xl font-bold mb-2">Colegio La Inmaculada</h3>
          <p className="text-sm">
            Formamos personas íntegras, líderes comprometidos con su comunidad.
          </p>
          <p className="text-sm mt-4">
            📍 Jr. Inmaculada #495, Pucalla, Peru
          </p>
          {/*<p className="text-sm">☎️ (01) 123-4567</p>//no cuenan con telefono*/}
          <p className="text-sm">✉️ ielipucallpa@hotmail.com </p>
          <p className="text-sm">📅 Horario: Lun a Vie, 7:00 AM-6:00 PM</p>
        </div>

        {/* Enlaces rápidos */}
        <div>
          <h4 className="text-xl font-semibold mb-3">Enlaces</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="/" className="hover:underline">Inicio</a></li>
            <li><a href="/historia" className="hover:underline">Historia</a></li>
            <li><a href="/Logros" className="hover:underline">Logros</a></li>
            <li><a href="/actividades" className="hover:underline">Actividades</a></li>
            <li><a href="/normas" className="hover:underline">Normas de Convivencia</a></li>
            <li><a href="/valores" className="hover:underline">Valores</a></li>
          </ul>
        </div>

        {/* Redes sociales */}
        <div>
          <h4 className="text-xl font-semibold mb-3">Síguenos</h4>
          <div className="flex space-x-4">
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-blue-800 p-2 rounded-full hover:bg-blue-600 hover:text-white transition"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-pink-500 p-2 rounded-full hover:bg-pink-500 hover:text-white transition"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.youtube.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-red-600 p-2 rounded-full hover:bg-red-600 hover:text-white transition"
            >
              <FaYoutube />
            </a>
          </div>
        </div>

        {/* Mapa ieli */}
      <div className="w-full h-48 md:h-full flex items-center justify-center">
        <iframe
        title="Ubicación del colegio La Inmaculada"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3031.397881979377!2d-74.53387480271597!3d-8.378287697996079!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x91a3bceedf589b67%3A0xe319689bd201737!2sInstituci%C3%B3n%20Educativa%20La%20Inmaculada!5e0!3m2!1ses-419!2spe!4v1746459817940!5m2!1ses-419!2spe"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        className="rounded-xl shadow"
        ></iframe>
      </div>
  </div>

      {/* Pie final */}
      <div className="border-t border-blue-700 pt-4 pb-6 text-center text-sm">
        &copy; {currentYear} Colegio La Inmaculada. Todos los derechos reservados.
      </div>
    </footer>
  );
};

export default Footer;
